/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";
import { Icon } from "@aws-amplify/ui-react";
export default function IconButtons(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    { overrides: { IconButtons: {} }, variantValues: { variant: "iconMoney" } },
    {
      overrides: {
        IconButtons: {
          paths: [
            {
              d: "M7.41531 8C9.61531 8 11.4153 6.2 11.4153 4C11.4153 1.8 9.61531 0 7.41531 0C5.21531 0 3.41531 1.8 3.41531 4C3.41531 6.2 5.21531 8 7.41531 8ZM11.9153 7.1C13.6153 8.5 16.1153 8.2 17.5153 6.5C18.9153 4.8 18.6153 2.3 16.9153 0.9C16.2153 0.3 15.3153 0 14.4153 0C13.5153 0 12.6153 0.3 11.9153 0.9C13.6153 2.3 13.9153 4.7 12.5153 6.5C12.4153 6.7 12.1153 6.9 11.9153 7.1ZM21.8153 15.9C21.2153 12.2 18.1153 9.5 14.4153 9.5C13.5153 9.5 12.7153 9.6 11.9153 9.9C14.5153 10.8 16.4153 13.1 16.8153 15.8C16.9153 16.3 16.5153 16.9 15.9153 16.9L15.8153 16.9L20.8153 16.9C21.4153 16.9 21.8153 16.5 21.8153 15.9C21.8153 15.9 21.8153 16 21.8153 15.9ZM7.41531 9.5C3.71531 9.5 0.515314 12.2 0.0153144 15.9C-0.0846856 16.4 0.315314 17 0.915314 17L1.01531 17L13.8153 17C14.4153 17 14.8153 16.6 14.8153 16L14.8153 15.9C14.3153 12.2 11.1153 9.5 7.41531 9.5Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.52%, 14.58%)" },
            },
          ],
        },
      },
      variantValues: { variant: "iconGrupo" },
    },
    {
      overrides: {
        IconButtons: {
          paths: [
            {
              d: "M8 16C9.77498 15.9996 11.4988 15.4054 12.897 14.312L17.293 18.708L18.707 17.294L14.311 12.898C15.405 11.4997 15.9996 9.77544 16 8C16 3.589 12.411 0 8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16ZM8 2C11.309 2 14 4.691 14 8C14 11.309 11.309 14 8 14C4.691 14 2 11.309 2 8C2 4.691 4.691 2 8 2Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(2px, 2px)" },
            },
            {
              d: "M9.412 6.586C9.791 6.966 10 7.468 10 8L12 8C12.0009 7.47443 11.8976 6.95389 11.6961 6.46848C11.4946 5.98308 11.1988 5.54242 10.826 5.172C9.312 3.66 6.687 3.66 5.174 5.172L6.586 6.588C7.346 5.83 8.656 5.832 9.412 6.586Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(2px, 2px)" },
            },
          ],
        },
      },
      variantValues: { variant: "iconSearch" },
    },
    {
      overrides: {
        IconButtons: {
          paths: [
            {
              d: "M10 0L10 5.5C10 5.89782 10.158 6.27936 10.4393 6.56066C10.7206 6.84196 11.1022 7 11.5 7L17 7L17 14C17 14.5304 16.7893 15.0391 16.4142 15.4142C16.0391 15.7893 15.5304 16 15 16L13 16L13 18C13 18.5304 12.7893 19.0391 12.4142 19.4142C12.0391 19.7893 11.5304 20 11 20L2 20C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 1.33227e-15 18.5304 0 18L0 6C0 5.46957 0.210714 4.96086 0.585786 4.58579C0.960859 4.21071 1.46957 4 2 4L4 4L4 2C4 1.46957 4.21071 0.960859 4.58579 0.585786C4.96086 0.210714 5.46957 4.44089e-16 6 0L10 0ZM4 6L2 6L2 18L11 18L11 16L6 16C5.46957 16 4.96086 15.7893 4.58579 15.4142C4.21071 15.0391 4 14.5304 4 14L4 6ZM12 0.043C12.3789 0.123355 12.7263 0.311992 13 0.586L16.414 4C16.688 4.27373 16.8766 4.62112 16.957 5L12 5L12 0.043Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "evenodd",
              style: { transform: "translate(16.67%, 8.33%)" },
            },
          ],
        },
      },
      variantValues: { variant: "iconDoc" },
    },
    {
      overrides: {
        IconButtons: {
          paths: [
            {
              d: "M4.97175 14.5794C4.85714 14.4687 4.76572 14.3363 4.70283 14.1899C4.63994 14.0435 4.60683 13.886 4.60545 13.7267C4.60406 13.5674 4.63443 13.4093 4.69476 13.2619C4.7551 13.1144 4.8442 12.9804 4.95688 12.8677C5.06955 12.7551 5.20353 12.666 5.35101 12.6056C5.49848 12.5453 5.6565 12.5149 5.81583 12.5163C5.97517 12.5177 6.13263 12.5508 6.27904 12.6137C6.42544 12.6766 6.55785 12.768 6.66855 12.8826C7.50767 13.722 8.57687 14.2936 9.7409 14.5252C10.9049 14.7568 12.1115 14.638 13.208 14.1837C14.3045 13.7295 15.2417 12.9603 15.9009 11.9734C16.5602 10.9865 16.912 9.82626 16.9118 8.63941C16.9118 8.32115 17.0382 8.01593 17.2632 7.79088C17.4883 7.56584 17.7935 7.43941 18.1118 7.43941C18.43 7.43941 18.7352 7.56584 18.9603 7.79088C19.1853 8.01593 19.3118 8.32115 19.3118 8.63941C19.3119 10.3009 18.8193 11.925 17.8963 13.3065C16.9733 14.688 15.6613 15.7647 14.1264 16.4006C12.5914 17.0364 10.9023 17.2027 9.27282 16.8786C7.6433 16.5544 6.14651 15.7543 4.97175 14.5794Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.53%, 14%)" },
            },
            {
              d: "M15.1826 12.0378C15.0514 12.1253 14.9044 12.1861 14.7498 12.2167C14.5952 12.2473 14.4361 12.2472 14.2815 12.2163C14.127 12.1855 13.98 12.1244 13.849 12.0368C13.718 11.9491 13.6056 11.8365 13.5182 11.7054C13.3415 11.4406 13.2773 11.1165 13.3396 10.8044C13.402 10.4922 13.5858 10.2176 13.8506 10.041L17.4506 7.64101C17.5817 7.55355 17.7287 7.49277 17.8833 7.46214C18.0379 7.43151 18.197 7.43164 18.3516 7.4625C18.5061 7.49337 18.6531 7.55438 18.7841 7.64204C18.9151 7.7297 19.0275 7.8423 19.115 7.97341C19.2024 8.10452 19.2632 8.25158 19.2938 8.40618C19.3244 8.56078 19.3243 8.7199 19.2935 8.87445C19.2626 9.02901 19.2016 9.17597 19.1139 9.30694C19.0263 9.43792 18.9137 9.55035 18.7826 9.63781L15.1826 12.0378Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.53%, 14%)" },
            },
            {
              d: "M21.5102 11.5734C21.6868 11.8382 21.751 12.1623 21.6887 12.4745C21.6263 12.7866 21.4425 13.0612 21.1778 13.2378C20.913 13.4144 20.5888 13.4787 20.2767 13.4163C19.9646 13.354 19.69 13.1702 19.5134 12.9054L17.1134 9.30541C17.0259 9.1743 16.9651 9.02724 16.9345 8.87264C16.9039 8.71804 16.904 8.55892 16.9348 8.40437C16.9972 8.09223 17.181 7.81764 17.4458 7.64101C17.7105 7.46438 18.0347 7.40017 18.3468 7.4625C18.6589 7.52484 18.9335 7.70862 19.1102 7.97341L21.5102 11.5734ZM16.7402 2.46061C16.8548 2.57131 16.9462 2.70372 17.0091 2.85013C17.072 2.99653 17.1051 3.15399 17.1065 3.31333C17.1078 3.47266 17.0775 3.63068 17.0171 3.77816C16.9568 3.92563 16.8677 4.05961 16.755 4.17228C16.6424 4.28496 16.5084 4.37406 16.3609 4.4344C16.2134 4.49473 16.0554 4.5251 15.8961 4.52371C15.7367 4.52233 15.5793 4.48922 15.4329 4.42633C15.2865 4.36344 15.154 4.27202 15.0434 4.15741C14.2042 3.31807 13.135 2.74644 11.971 2.51484C10.807 2.28324 9.60039 2.40206 8.5039 2.85628C7.4074 3.31049 6.47025 4.0797 5.81098 5.0666C5.1517 6.0535 4.79993 7.21376 4.80015 8.40061C4.80015 8.71887 4.67372 9.0241 4.44868 9.24914C4.22363 9.47418 3.91841 9.60061 3.60015 9.60061C3.28189 9.60061 2.97667 9.47418 2.75162 9.24914C2.52658 9.0241 2.40015 8.71887 2.40015 8.40061C2.40003 6.73916 2.89262 5.11499 3.81561 3.7335C4.73861 2.35202 6.05055 1.27528 7.58553 0.63945C9.1205 0.0036236 10.8096 -0.162725 12.4391 0.161441C14.0686 0.485607 15.5654 1.28573 16.7402 2.46061Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.53%, 14%)" },
            },
            {
              d: "M6.53055 5.00221C6.79534 4.82558 7.11946 4.76136 7.43159 4.8237C7.74373 4.88604 8.01832 5.06982 8.19495 5.33461C8.37158 5.5994 8.43579 5.92352 8.37346 6.23565C8.31112 6.54779 8.12734 6.82238 7.86255 6.99901L4.26135 9.39901C4.13024 9.48647 3.98318 9.54725 3.82858 9.57788C3.67398 9.60851 3.51486 9.60839 3.36031 9.57752C3.20575 9.54665 3.05879 9.48565 2.92782 9.39798C2.79684 9.31032 2.68441 9.19772 2.59695 9.06661C2.42032 8.80182 2.3561 8.4777 2.41844 8.16557C2.48078 7.85343 2.66456 7.57884 2.92935 7.40221L6.52935 5.00221L6.53055 5.00221Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.53%, 14%)" },
            },
            {
              d: "M0.201749 5.46661C0.114289 5.3355 0.0535094 5.18844 0.0228809 5.03384C-0.00774766 4.87924 -0.00762532 4.72012 0.0232409 4.56557C0.0541071 4.41101 0.115113 4.26405 0.202774 4.13308C0.290436 4.0021 0.403038 3.88967 0.534149 3.80221C0.665261 3.71475 0.812316 3.65397 0.966917 3.62334C1.12152 3.59271 1.28064 3.59284 1.43519 3.6237C1.58975 3.65457 1.73671 3.71557 1.86768 3.80324C1.99866 3.8909 2.11109 4.0035 2.19855 4.13461L4.59855 7.73461C4.68601 7.86572 4.74679 8.01278 4.77742 8.16738C4.80805 8.32198 4.80792 8.4811 4.77706 8.63565C4.74619 8.79021 4.68519 8.93717 4.59752 9.06814C4.50986 9.19912 4.39726 9.31155 4.26615 9.39901C4.13504 9.48647 3.98798 9.54725 3.83338 9.57788C3.67878 9.60851 3.51966 9.60839 3.36511 9.57752C3.21055 9.54665 3.06359 9.48565 2.93262 9.39799C2.80164 9.31032 2.68921 9.19772 2.60175 9.06661L0.201749 5.46661Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.53%, 14%)" },
            },
          ],
        },
      },
      variantValues: { variant: "iconPrece" },
    },
    {
      overrides: {
        IconButtons: {
          paths: [
            {
              d: "M16.9488 7.64761C16.4488 3.04761 12.3488 -0.452392 7.64878 0.0476082C2.94878 0.547608 -0.451215 4.64761 0.0487847 9.34761C0.248785 11.3476 1.14878 13.1476 2.54878 14.5476L7.84878 19.8476C8.24878 20.2476 8.84879 20.2476 9.24879 19.8476L14.5488 14.5476C16.2488 12.7476 17.1488 10.2476 16.9488 7.64761ZM8.44878 13.0476C5.94878 13.0476 3.94878 11.0476 3.94878 8.54761C3.94878 6.04761 5.94878 4.04761 8.44878 4.04761C10.9488 4.04761 12.9488 6.04761 12.9488 8.54761C12.9488 10.9476 10.9488 13.0476 8.44878 13.0476Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(14.8%, 8.13%)" },
            },
          ],
        },
      },
      variantValues: { variant: "iconLocation" },
    },
    {
      overrides: {
        IconButtons: {
          paths: [
            {
              d: "M0 0L24 0L24 24L0 24L0 0Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
            {
              d: "M15.2 12C15.2 13.7673 13.7673 15.2 12 15.2C10.2327 15.2 8.8 13.7673 8.8 12C8.8 10.2327 10.2327 8.8 12 8.8C13.7673 8.8 15.2 10.2327 15.2 12Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
            {
              d: "M9 2L7.17 4L4 4C2.9 4 2 4.9 2 6L2 18C2 19.1 2.9 20 4 20L20 20C21.1 20 22 19.1 22 18L22 6C22 4.9 21.1 4 20 4L16.83 4L15 2L9 2ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "evenodd",
              style: { transform: "translate(0%, 0%)" },
            },
          ],
        },
      },
      variantValues: { variant: "iconCamera" },
    },
    {
      overrides: {
        IconButtons: {
          paths: [
            {
              d: "M19.3125 10.5L12.75 10.5C12.1533 10.5 11.581 10.2629 11.159 9.84099C10.7371 9.41903 10.5 8.84674 10.5 8.25L10.5 1.6875C10.5 1.63777 10.4802 1.59008 10.4451 1.55492C10.4099 1.51975 10.3622 1.5 10.3125 1.5L7.81641 1.5C7.72886 1.33788 7.62689 1.18397 7.51172 1.04016C6.97125 0.369375 6.16828 0 5.25 0C3.48375 0 2.25 1.38797 2.25 3.375L2.25 10.125C2.25 11.2969 3.20344 12 4.125 12C4.37198 12.0027 4.61701 11.956 4.84571 11.8628C5.07442 11.7695 5.28219 11.6315 5.45684 11.4568C5.63149 11.2822 5.7695 11.0744 5.86277 10.8457C5.95604 10.617 6.0027 10.372 6 10.125L6 3C6 2.80109 5.92098 2.61032 5.78033 2.46967C5.63968 2.32902 5.44891 2.25 5.25 2.25C5.05109 2.25 4.86032 2.32902 4.71967 2.46967C4.57902 2.61032 4.5 2.80109 4.5 3L4.5 10.125C4.50163 10.1747 4.49305 10.2242 4.47478 10.2704C4.45651 10.3166 4.42895 10.3586 4.39379 10.3938C4.35864 10.4289 4.31665 10.4565 4.27041 10.4748C4.22418 10.493 4.17469 10.5016 4.125 10.5C4.02047 10.5 3.75 10.4325 3.75 10.125L3.75 3.375C3.75 2.46844 4.14422 1.5 5.25 1.5C6.64172 1.5 6.75 2.91328 6.75 3.34594L6.75 9.84984C6.75 10.6678 6.49359 11.4075 6.02766 11.9339C5.55469 12.4688 4.89703 12.75 4.125 12.75C3.35297 12.75 2.69531 12.4688 2.22234 11.9339C1.75641 11.4075 1.5 10.6678 1.5 9.84984L1.5 6C1.5 5.80109 1.42098 5.61032 1.28033 5.46967C1.13968 5.32902 0.948912 5.25 0.75 5.25C0.551088 5.25 0.360322 5.32902 0.21967 5.46967C0.0790176 5.61032 6.66134e-16 5.80109 0 6L0 9.84984C0 12.2644 1.55578 14.0512 3.75 14.2341L3.75 19.5C3.75 20.2957 4.06607 21.0587 4.62868 21.6213C5.19129 22.1839 5.95435 22.5 6.75 22.5L16.5 22.5C17.2957 22.5 18.0587 22.1839 18.6213 21.6213C19.1839 21.0587 19.5 20.2957 19.5 19.5L19.5 10.6875C19.5 10.6378 19.4802 10.5901 19.4451 10.5549C19.4099 10.5198 19.3622 10.5 19.3125 10.5Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 4.17%)" },
            },
            {
              d: "M12.75 8.9282L18.8348 8.9282C18.8533 8.92812 18.8714 8.92258 18.8867 8.91228C18.9021 8.90197 18.914 8.88736 18.9211 8.87027C18.9281 8.85319 18.93 8.8344 18.9264 8.81627C18.9228 8.79814 18.914 8.78147 18.9009 8.76836L12.1598 2.02726C12.1467 2.01423 12.1301 2.00536 12.1119 2.00178C12.0938 1.9982 12.075 2.00005 12.0579 2.00711C12.0408 2.01418 12.0262 2.02613 12.0159 2.04148C12.0056 2.05682 12.0001 2.07487 12 2.09336L12 8.1782C12 8.37711 12.079 8.56788 12.2197 8.70853C12.3603 8.84918 12.5511 8.9282 12.75 8.9282Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 4.17%)" },
            },
          ],
        },
      },
      variantValues: { variant: "iconDocumentAttach" },
    },
    {
      overrides: {
        IconButtons: {
          paths: [
            {
              d: "M0.292444 0.293762C0.199741 0.386276 0.126193 0.496165 0.0760117 0.617138C0.0258302 0.738111 -1.77636e-15 0.867794 0 0.998762C-1.77636e-15 1.12973 0.0258302 1.25941 0.0760117 1.38039C0.126193 1.50136 0.199741 1.61125 0.292444 1.70376L4.17244 5.58376L0.292444 9.46376C0.105467 9.65074 0.000423431 9.90434 0.000423431 10.1688C0.000423431 10.4332 0.105467 10.6868 0.292444 10.8738C0.479422 11.0607 0.733018 11.1658 0.997444 11.1658C1.26187 11.1658 1.51547 11.0607 1.70244 10.8738L6.29244 6.28376C6.38515 6.19125 6.4587 6.08136 6.50888 5.96039C6.55906 5.83941 6.58489 5.70973 6.58489 5.57876C6.58489 5.44779 6.55906 5.31811 6.50888 5.19714C6.4587 5.07616 6.38515 4.96628 6.29244 4.87376L1.70244 0.283762C1.32244 -0.0962379 0.682444 -0.0962377 0.292444 0.293762Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(37.57%, 26.73%)" },
            },
          ],
        },
      },
      variantValues: { variant: "next" },
    },
    {
      overrides: {
        IconButtons: {
          paths: [
            {
              d: "M6.29244 0.292444C6.19993 0.199741 6.09004 0.126193 5.96907 0.0760117C5.8481 0.0258302 5.71841 8.88178e-16 5.58744 0C5.45648 0 5.32679 0.0258302 5.20582 0.0760117C5.08485 0.126193 4.97496 0.199741 4.88244 0.292444L0.292444 4.88244C0.199741 4.97496 0.126193 5.08485 0.0760117 5.20582C0.0258302 5.32679 0 5.45648 0 5.58744C0 5.71841 0.0258302 5.8481 0.0760117 5.96907C0.126193 6.09004 0.199741 6.19993 0.292444 6.29244L4.88244 10.8824C4.97503 10.975 5.08494 11.0485 5.2059 11.0986C5.32687 11.1487 5.45651 11.1745 5.58744 11.1745C5.71837 11.1745 5.84802 11.1487 5.96899 11.0986C6.08995 11.0485 6.19986 10.975 6.29244 10.8824C6.38503 10.7899 6.45847 10.68 6.50857 10.559C6.55868 10.438 6.58447 10.3084 6.58447 10.1774C6.58447 10.0465 6.55868 9.91687 6.50857 9.7959C6.45847 9.67494 6.38503 9.56503 6.29244 9.47244L2.41244 5.58244L6.29244 1.70244C6.68244 1.31244 6.67244 0.672444 6.29244 0.292444Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(35.07%, 26.74%)" },
            },
          ],
        },
      },
      variantValues: { variant: "back" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Icon
      width="24px"
      height="24px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      position="relative"
      padding="0px 0px 0px 0px"
      viewBox={{ minX: 0, minY: 0, width: 24, height: 24 }}
      paths={[
        {
          d: "M5.48 7.9C3.21 7.31 2.48 6.7 2.48 5.75C2.48 4.66 3.49 3.9 5.18 3.9C6.96 3.9 7.62 4.75 7.68 6L9.89 6C9.82 4.28 8.77 2.7 6.68 2.19L6.68 0L3.68 0L3.68 2.16C1.74 2.58 0.18 3.84 0.18 5.77C0.18 8.08 2.09 9.23 4.88 9.9C7.38 10.5 7.88 11.38 7.88 12.31C7.88 13 7.39 14.1 5.18 14.1C3.12 14.1 2.31 13.18 2.2 12L0 12C0.12 14.19 1.76 15.42 3.68 15.83L3.68 18L6.68 18L6.68 15.85C8.63 15.48 10.18 14.35 10.18 12.3C10.18 9.46 7.75 8.49 5.48 7.9Z",
          fill: "rgba(255,255,255,1)",
          fillRule: "nonzero",
          style: { transform: "translate(26.33%, 12.5%)" },
        },
      ]}
      {...getOverrideProps(overrides, "IconButtons")}
      {...rest}
    ></Icon>
  );
}
